import { FormLayout, Remark } from "@careinfo/layout";
import { AccessControl } from "@careinfo/permission-required";
import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import moment from "moment";
import { ClipboardEvent, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import APIS from "../../constant/EndPoint";
import { createRunsheetValidationForm } from "../../utils/validationSchemas";
import Button from "../Reusable/Button";
import Card from "../Reusable/Card";
import ComboboxInput from "../Reusable/ComboboxInput";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import TrackingCell from "../Reusable/DataTable/TrackingCell";
import Modal from "../Reusable/Modal";
import Spinner from "../Reusable/Spinner";
import TextField from "../Reusable/TextInput";

const EditReceiveManifest = (props: any) => {
  const {
    handleEdit,
    isLoading,
    data,
    handlePrint,
    isPrintLoading,
    setIsCorrect,
    openalertPopup,
    setOpenAlertPopup,
    handlecheckConsignments,
  } = props;

  const [searchParams, setSearchParms] = useSearchParams({
    limit: "10",
    page: "0",
    searchQuery: "",
  });
  const [openReviewModal, setOpenReviewModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState("");
  const [freightValue, setFreightValue] = useState(null);
  const [advanceValue, setAdvanceValue] = useState(null);
  const [tracking_number, setTrackingNumber] = useState();
  const [balance, setBalance] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createRunsheetValidationForm),
    defaultValues: async () => {
      return {
        driver: {
          name: data?.driver?.user?.full_name,
          id: data?.driver?.id,
        },
        vehicle: {
          name: data?.vehicle?.license_number,
          id: data?.vehicle?.id,
        },
        destination_branch: {
          name: data?.destination_branch?.name,
          id: data?.destination_branch?.id,
        },
        freight: data?.freight,
        advance: data?.advance,
        balance: data?.balance,
        note: data?.note,
      };
    },
  });
  const checkedAllItems = searchParams.get("selectAllItems") === "1";
  const isSelected = (value: string) => {
    const selectedItems = searchParams.get("selectedItems")?.split(",");
    if (!selectedItems) {
      return false;
    }
    return selectedItems.includes(value);
  };
  const handleKeyDown = (event: any) => {
    if (event.key === "Enter" && event.target.value?.length > 0) {
      if (!data?.is_active) {
        setTrackingNumber(event.target.value);
        handlecheckConsignments(event.target.value, setError);
      }
      event.target.value = "";
    }
  };
  const searchQuery = searchParams.get("searchQuery");
  const handleIndividualSelect = (value: string) => {
    let selectedItems = searchParams.get("selectedItems")?.split(",");
    if (!selectedItems || !selectedItems === undefined) {
      searchParams.set("selectedItems", value);
      setSearchParms(searchParams);
      return;
    }
    let itemIndex = selectedItems?.findIndex((item) => item === value);
    if (itemIndex > -1) {
      selectedItems.splice(itemIndex, 1);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(",")
        .toString();
      if (newSelectedItems.length) {
        searchParams.set("selectedItems", newSelectedItems);
      } else {
        searchParams.delete("selectedItems");
      }
      searchParams.set("selectAllItems", "0");
      setSearchParms(searchParams);
    } else {
      selectedItems?.push(value);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(",")
        .toString();
      searchParams.set("selectedItems", newSelectedItems);
      setSearchParms(searchParams);
    }
  };
  const handleSelectAll = (table: any) => {
    const {
      options: { data: tableData },
    } = table;
    const isSelected = searchParams.get("selectAllItems");
    if (isSelected === "1") {
      searchParams.set("selectAllItems", "0");
      searchParams.delete("selectedItems");
      setSearchParms(searchParams);
    } else {
      const selectedItems = tableData
        ?.map((item: any) => item.id)
        .join(",")
        .toString();
      searchParams.set("selectAllItems", "1");
      searchParams.set("selectedItems", selectedItems);
      setSearchParms(searchParams);
    }
  };

  const orderDefaultColumns: any = [
    {
      id: "select",
      header: ({ table }: any) => {
        return (
          <input
            type="checkbox"
            checked={checkedAllItems}
            onChange={() => handleSelectAll(table)}
            className={tw`cursor-pointer`}
          />
        );
      },
      cell: ({ row }: any) => (
        <input
          type="checkbox"
          checked={isSelected(row?.original?.id)}
          onChange={() => handleIndividualSelect(row?.original?.id)}
          className={tw`cursor-pointer`}
        />
      ),
    },
    {
      header: "Date",
      accessorKey: "order.created",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            {getValue() ? (
              <p>{moment(getValue()).format("YY-MM-DD HH:mm:ss")}</p>
            ) : (
              "N/A"
            )}
          </>
        );
      },
    },
    {
      header: "Waybill",
      accessorKey: "order.tracking_number",
      cell: TrackingCell,
    },
    {
      header: "Origin",
      accessorKey: "order.pickup_branch.name",
      cell: NACell,
    },
    {
      header: "Sender",
      accessorKey: "order.sender.full_name",
      cell: NACell,
    },
    {
      header: "Destination",
      accessorKey: "order.destination.name",
      cell: NACell,
    },

    {
      header: "Receiver",
      accessorKey: "order.receiver.full_name",
      cell: NACell,
    },

    {
      header: "Pcs",
      accessorKey: "order.piece",
      cell: NACell,
    },

    {
      header: "Remarks",
      accessorKey: "order.remarks",
      cell: ({ row, getValue }: any) => (
        <button
          onClick={() => {
            setSelectedOrder(row?.original?.order.id);
            setOpenReviewModal(true);
          }}
        >
          {getValue()} Remarks
        </button>
      ),
    },
    {
      header: "Received",
      accessorKey: "is_received",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            {getValue() ? (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18457 2.99721 7.13633 4.39828 5.49707C5.79935 3.85782 7.69279 2.71538 9.79619 2.24015C11.8996 1.76491 14.1003 1.98234 16.07 2.86M22 4L12 14.01L9.00001 11.01"
                  stroke="#26C943"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            ) : (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                  stroke="red"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            )}
          </>
        );
      },
    },
  ];

  const preventCopyPaste = (e: ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    toast.error("Copy and paste is not allowed here");
  };

  const handleOrderDetailNavigate = (row: any) => {
    console.log(row);
  };

  const handleFreightvalue = (event) => {
    setFreightValue(event.target.value);
  };
  const handleAdvancevalue = (event) => {
    setAdvanceValue(event.target.value);
  };
  useEffect(() => {
    let value = freightValue - advanceValue;
    setBalance(value);
  }, [freightValue, advanceValue]);

  const handleOrderReceive = () => {
    setIsCorrect(true);
    handlecheckConsignments(tracking_number, setError);
    // setOpenAlertPopup(!openalertPopup)
  };

  return (
    <>
      <AccessControl
        children={
          <FormLayout
            handleSubmit={handleSubmit}
            handleFormSubmit={handleEdit}
            setError={setError}
            buttonLabel={"Update"}
            isLoading={isLoading}
            disabled={!data?.is_active}
          >
            <div className={tw`grid  md:grid-cols-3 gap-x-4 mx-4`}>
              <ComboboxInput
                url={APIS.VEHICLE}
                queryKey={"vehicle"}
                register={register("vehicle")}
                errors={errors?.vehicle}
                name={"vehicle"}
                label={"Vehicle Number"}
                setValue={setValue}
                placeholder={"Search vehicle"}
                getValues={getValues}
                clearErrors={clearErrors}
                disabled={!data?.is_active}
              />
              <ComboboxInput
                url={APIS.DRIVER}
                queryKey={"driver"}
                register={register("driver")}
                errors={errors?.driver}
                name={"driver"}
                label={"Driver"}
                setValue={setValue}
                placeholder={"Search driver"}
                getValues={getValues}
                clearErrors={clearErrors}
                disabled={!data?.is_active}
              />
              <ComboboxInput
                url={APIS.BRANCH}
                queryKey={"branch"}
                register={register("destination_branch")}
                errors={errors?.destination_branch}
                name={"destination_branch"}
                label={"Branch"}
                setValue={setValue}
                placeholder={"Search branch"}
                getValues={getValues}
                clearErrors={clearErrors}
                disabled={!data?.is_active}
              />
              <div className={tw`w-full my-2 text-left mt-4`}>
                <label htmlFor="">
                  Freight
                  <input
                    name={"freight"}
                    type={"number"}
                    value={freightValue}
                    {...register("freight")}
                    disabled={!data?.is_active}
                    onChange={handleFreightvalue}
                    className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
                  />
                </label>
                {errors && (
                  <p className={tw`text-red-500 text-xs my-1`}>
                    {errors?.frieght?.message}
                  </p>
                )}
              </div>
              <div className={tw`w-full my-2 text-left mt-4`}>
                <label htmlFor="">
                  Advance
                  <input
                    name={"advance"}
                    type={"number"}
                    value={advanceValue}
                    disabled={!data?.is_active}
                    {...register("advance")}
                    onChange={handleAdvancevalue}
                    className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
                  />
                </label>
                {errors && (
                  <p className={tw`text-red-500 text-xs my-1`}>
                    {errors?.advance?.message}
                  </p>
                )}
              </div>

              <div className={tw`w-full my-2 text-left mt-4`}>
                <label htmlFor="">
                  Balance
                  <input
                    name={"balance"}
                    type={"number"}
                    value={balance}
                    {...register("balance")}
                    disabled={true}
                    className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
                  />
                </label>
                {errors && (
                  <p className={tw`text-red-500 text-xs my-1`}>
                    {errors?.balance?.message}
                  </p>
                )}
              </div>
            </div>
            <div className={tw`mx-4`}>
              <TextField
                label={"Note"}
                register={register(`note`, { disabled: !data?.is_active })}
                errors={errors?.note}
              />
            </div>
          </FormLayout>
        }
        allowedPermissions={["can_editupdate_manifest"]}
      />
      <Card title="Barcode Scanner">
        <>
          <div className={tw`grid grid-cols-1 w-full`}>
            <div>
              <input
                type="text"
                {...register("tracking_number")}
                className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
                onPaste={preventCopyPaste}
                onKeyDown={handleKeyDown}
              />
            </div>
          </div>
        </>
      </Card>

      <DataTable
        url={`${APIS.MANIFEST_ITEMS}`}
        queryKey={"manifest-items"}
        columns={orderDefaultColumns}
        params={{ manifest: data?.id, order_by: "-modified" }}
        tableName={"edit-manifest"}
        handleDetailNavigate={handleOrderDetailNavigate}
        actionMenu={
          <div className={tw`w-full text-right  `}>
            <button
              className={tw`p-1 px-5 rounded-sm border border-primary mr-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
              disabled={isPrintLoading}
              onClick={() => handlePrint()}
            >
              {isPrintLoading ? <Spinner /> : "Print"}
            </button>
          </div>
        }
      />
      <Modal
        isOpen={openReviewModal}
        setIsOpen={setOpenReviewModal}
        title={"Remark"}
        children={
          <>
            <Remark selectedOrder={selectedOrder} />
          </>
        }
      />
      <Modal
        isOpen={openalertPopup}
        setIsOpen={setOpenAlertPopup}
        title={"Are you sure you want to receive this Order?"}
        children={
          <>
            <div
              className={tw`flex flex-col gap-y-4 justify-center items-center h-56 w-full`}
            >
              <div>
                This order was not sent to you, are you sure you want to receive
                this order?
              </div>
              <div className="flex justify-center items-center gap-x-4 mt-10">
                <div className={tw`w-32`}>
                  <Button label={"Yes"} onClick={() => handleOrderReceive()} />
                </div>
                <div className={tw`w-32`}>
                  <Button
                    label={"No"}
                    onClick={() => setOpenAlertPopup(!openalertPopup)}
                  />
                </div>
              </div>
            </div>
          </>
        }
      />
    </>
  );
};

export default EditReceiveManifest;
